<template>
    <div class="page-wrapper" v-if="newsData">
        <div class="video-player-wrapper" v-if="newsData.videoUrl">
            <div class="poster" v-show="!isPlay">
                <img :src="newsData.coverUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt="">
                <span @click="playVideo" class="pointer"></span>
            </div>
          <video v-show="isPlay" ref="newsVideo" :src="newsData.videoUrl" x5-playsinline playsinline webkit-playsinline controls></video>
        </div>
        <div class="news-detail-wrapper clearfix" v-if="!isPhone"  :class="query.columnId && `news-detail-${$Common.Base64.decode(query.columnId)}`">
            <div class="news-details-left" :class="{'width100': !(recommendNewsList || nextNews)}">
                <div class="content-wrapper" v-if="newsData">
                    <div class="content-title">
                        {{newsData.title}}
                    </div>
                    <div class="content-meta clearfix">
                        <span class="meta-source">{{newsData.source}}</span>
                        <span class="meta-time">{{newsData.publishTime | formatPublishTime}}</span>
                        <!-- <span class="meta-review" v-show="newsData.readNum">
                            <img style="width: 1rem" src="./../assets/img/eyes.png" alt="">{{newsData.readNum}}
                        </span> -->
                    </div>
                    <div ref="content" class="content-details" v-html="newsData.content"></div>
                </div>
            </div>
            <div class="news-details-right" v-if="recommendNewsList || nextNews">
                <div class="news-recommond aside-part" v-if="recommendNewsList">
                    <div class="title">推荐阅读</div>
                    <div class="news-part">
                      <div class="news pointer" v-for="item in recommendNewsList" :key="item.itemId" @click="toDetail(item)">
                        <div class="news-title line-2">
                            {{item.itemTitle}}
                        </div>
                        <div class="news-meta">
                            <span>{{item.sourceName}}</span>
                            <!-- <span>{{item.publishShowTime}}</span> -->
                        </div>
                      </div>
                    </div>                                                                                                                                                                                   
                </div>
                <div class="news-next aside-part" v-if="nextNews">
                    <div class="title">下一篇</div>
                    <div class="news-part">
                        <div class="news pointer" @click="toDetail(nextNews)">
                            <div class="news-title line-2">
                                {{nextNews.itemTitle}}
                            </div>
                            <div class="news-meta">
                                <span>{{nextNews.sourceName}}</span>
                                <!-- <span>{{nextNews.publishShowTime}}</span> -->
                            </div>
                      </div>
                    </div> 
                </div>
            </div>
        </div>
        <div class="wap-news-detail" v-if="isPhone"  :class="query.columnId && `wap-news-${$Common.Base64.decode(query.columnId)}`">
            <div class="news-wrapper">
                <div class="title">
                    {{newsData.title}}
                </div>
                <div class="meta">
                    <span>{{newsData.source}}</span>
                    <span>{{newsData.publishTime | formatPublishTime}}</span>
                </div>
                <div class="content" v-html="newsData.content"></div>
            </div>
            <div class="related-news" v-if="recommendNewsList">
                <div class="related-title">相关推荐</div>
                <NewsList :isRecommend="true" :list="recommendNewsList" :columnId="query.columnId ? query.columnId : null" />
            </div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>
import NewsList from '@/components/NewsList.vue';
import GoHome from '@/components/GoHome.vue';
import { mapMutations, mapState } from 'vuex';
export default {
    name: 'NewsDetails',
    data() {
        return {
            id: null,
            newsData: null,
            recommendNewsList: null,
            nextNews: null,
            isPlay: false, // 视频新闻视频播放标志
            imgLoaded: `this.style.background = 'none'`,
            errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"',
            query: null, // 用于下一篇新闻
            channelId: null // 用于下一篇新闻
        }
    },
    components: {
        NewsList,
        GoHome
    },
    created() {
        this.id = this.$route.params.id;
        this.query = this.$route.query || {};
        if(!this.$Common.Base64.decode(this.id)) {
            return;
        }
        this.getDetail();
    },

    methods: {
        ...mapMutations(['setLoadingShow']),
        playVideo() {
            this.isPlay = true;
            this.$nextTick(() => {
                this.$refs.newsVideo && this.$refs.newsVideo.play();
            })
        },
        // 定义 handleImageLoad 函数
        handleImageLoad(event) {
            const img = event.target; // 获取触发事件的图片元素
            console.log('图片加载完成:', img);
            let width
            if(img.style.width){
                width = Number.parseInt(img.style.width)
                
            }else{
                width = img.naturalWidth
            }
            // `calc(${width} / var(--scaling))`
            // 在这里添加自定义逻辑
            img.style.width = `${width / window.devicePixelRatio}px`
        },
        // 处理富文本中的 <img> 标签
        processRichText(richText) {
            const imgRegex = /<img[^>]+>/g;
            return richText.replace(imgRegex, (imgTag) => {
                // 如果已经有 onload 属性，替换它
                if (/onload=(["'])[^"']*\1/i.test(imgTag)) {
                    return imgTag.replace(/onload=(["'])[^"']*\1/i, 'onload="handleImageLoad"');
                }
                // 如果没有 onload 属性，直接添加
                return imgTag.replace(/>$/, ' :onload="handleImageLoad">');
            });
        },
        getDetail() {
            const params = {
                newsId: this.$Common.Base64.decode(this.id),
                channelId: this.$route.params.channelId ? this.$Common.Base64.decode(this.$route.params.channelId) : null,
                newsDetailSupport: '11000',
                queryAllImg: true,
            }
            if (!this.isPhone) {
                params.subjectId = this.query.subjectId ? this.$Common.Base64.decode(this.query.subjectId) : '',
                params.expireSign = this.query.expireSign ? this.query.expireSign : ''
            }
            this.$axios.post(this.$ApiInfo.getNewsDetail,params).then(res => {
                this.newsData = res.item;
                // this.newsData.content = this.processRichText(this.newsData.content)
                this.$nextTick(() => {
                    this.$refs.content.querySelectorAll('img').forEach((img) => {
                        img.onload = this.handleImageLoad;
                    });
                });
                this.isPhone && this.$Common.onShare({
                    shareTitle: res.item.title,
                    shareUrl: window.location.href
                })
                this.setLoadingShow(false);
                res.item.title && (document.title = res.item.title);
                if (res.nest) {
                    this.nextNews = res.nest;
                }
                if (res.recommend) {
                    this.recommendNewsList = res.recommend.length > 3 ? res.recommend.slice(0, 3) : res.recommend;
                }
                if (res.channel) {
                    this.channelId = res.channel.id
                }
            })
        },
        getRecommendNews() {
            this.$axios.post(
                this.$ApiInfo.getRecommendNews,
                {
                    newsId: this.$Common.Base64.decode(this.id)
                }
            ).then(data => {
                data && data.length && (this.recommendNewsList = data);  
            })
        },
        toDetail(item) {
            //统计外链文章
            if(item.flag == 4){
                this.$axios.post(
                    this.$ApiInfo.getLink,
                    {
                        newsId: item.itemId,
                    }
                ).then(res => {
                    console.log(res)
                })
            }
            // 辟谣没有直播和图集
            if (item.flag == 2 || item.flag == 5) return
            let url = ''
            // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
            switch (item.flag) {
                case 0:
                    url = this.$router.resolve({
                        path: this.channelId ? `/news/${this.$Common.Base64.encode(item.itemId)}}/${this.$Common.Base64.encode(this.channelId)}` : `/news/${this.$Common.Base64.encode(item.itemId)}}`
                    })['href']
                    break;
                case 1:
                    url = this.$router.resolve({
                        path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
                    })['href']
                    break;
                case 3:
                    url = this.$router.resolve({
                        path: `/news/${this.$Common.Base64.encode(item.itemId)}`
                    })['href']
                    break;
                case 4:
                    url = item.itemExternalUrl
                    break;
                default:
                    break;
            }
            window.open(url)
        },
        dealQuery() {
            let obj = {};
            this.query.type && Object.assign(obj, {type: this.query.type});
            this.query.columnId && Object.assign(obj, {columnId: this.query.columnId});
            this.query.subjectId && Object.assign(obj, {subjectId: this.query.subjectId});
            this.query.skId && Object.assign(obj, {skId: this.query.skId});
            this.query.channelId && Object.assign(obj, {channelId: this.query.channelId});
            this.query.channelType && Object.assign(obj, {channelType: this.query.channelType});
            return obj;
        }
    },
    computed: {
        isPhone() {
            return this.$Common.Attribute.isMb();
        }
    }
}
</script>
<style lang="less">
.video-player-wrapper {
  width: 100%;
  height: 33.1875rem;
  text-align: center;
  background: #000;
  .poster {
      width: 100%;
      height: 100%;
      position: relative;
      text-align: center;
      img {
          width: auto;
          max-width: 100%;
          height: 100%;
      }
      span {
          display: inline-block;
          width: 6.3125rem;
          height: 6.3125rem;
          background: url('./../assets/img/video_play.png') center no-repeat;
          background-size: cover;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
      }
  }
  video {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
  }
}

.wap-wrapper {
    .video-player-wrapper {
        height: 56.267vw;
        .poster {
            span {
                width: 13.333vw;
                height: 13.333vw;
            }
        }
    }
}

.news-detail-wrapper {
    margin-top: 1.25rem;
    // 网友故事字体放大
    &.news-detail-208 {
        .news-details-left {
            .content-title {
                font-size: 1.63rem;
                margin-bottom: 1.25rem;
                line-height: 2rem;
            }
            .content-meta {
                margin-bottom: 1.88rem;
            }
            .content-details {
                font-size: 1.13rem;
                line-height: 2rem;
                
            }
        }
        .news-details-right {
            .aside-part {
                .title {
                    font-size: 1.19rem;
                    line-height: 1.63rem;
                }
                .news-part {
                    .news {
                        .news-title {
                            font-size: 1rem;
                            line-height: 1.5rem;
                        }
                    }
                }
            }
        }
    }
    .news-details-left {
        float: left; 
        background: #fff;
        padding: 1.4375rem 1.75rem;
        width: 47.125rem;
        box-sizing: border-box;
        .content-title {
            font-size: 1.375rem;
            line-height: 1.5625rem;
            color: #333333;
            font-weight: 600;
            margin-bottom: 0.75rem;
        }
        .content-meta {
            margin-bottom: 2.5rem;
            line-height: 0.875rem;
            span {
                font-size: 0.875rem;
                color: #999999;
                float: left;
                margin-right: 0.625rem;
                img {
                    // vertical-align: middle;
                }
            }
        }
        .content-details {
            color: #333333;
            font-size: 0.9375rem;
            line-height: 1.4375rem;
            video {
                max-height: 25rem !important;
            }
            img{
                width:auto;
                height: auto;
                max-width: 100%;
            }
        }
    }
    .width100 {
        width: 100%;
    }
    .news-details-right {
        float: right;
        width: 15.375rem;
        padding: 1.1875rem 0.9375rem;
        background: #FAFCFF;
        box-sizing: border-box;
        .aside-part {
          .title {
            font-size: 1.1875rem;
            line-height: 1.1875rem;
            padding-left: 0.5rem;
            border-left: 0.25rem solid #006DF1;
            color: #333333;
            font-weight: 600;
          }
          .news-part {
            margin-top: 0.9375rem;
            .news {
              margin-bottom: 1.25rem;
              .news-title {
                font-size: 0.8125rem;
                color: #000;
                line-height: 1.3125rem;
                margin-bottom: 0.3125rem;
              }
              .news-meta {
                font-size: 0.75rem;
                color: #999999;
                span {
                  margin-right: 0.3125rem;
                }
              }
            }
          }
        }
    }
}

.wap-news-detail {
    &.wap-news-208 {
        .news-wrapper  {
            .title {
                font-size: 6.667vw;
                line-height: 9.352vw;
            }
            .meta { 
                font-size: 3.241vw;
                line-height: 4.444vw;
            }
            .content {
                font-size: 5.37vw;
                line-height: 9.074vw;
            }
        }
        .related-news {
            .related-title {
                font-size: 5.37vw; 
                line-height: 4.815vw;
            }
        }
    }
    .news-wrapper {
        padding: 4.667vw 4vw;
        .title {
            font-size: 6.667vw;
            line-height: 9.333vw;
            color: #333333;
            margin-bottom: 3.2vw;
        }
        .meta {
            color: #999999;
            font-size: 3.2vw;
            span {
                margin-right: 4.267vw;
            }
            margin-bottom: 2.667vw;
        }
        .content {
            color: #333333;
            font-size: 4.533vw;
            line-height: 8vw;
            img{
                width:auto;
                height: auto;
                max-width: 100%;
            }
        }
    }
    .related-news {
        border-top: 1.733vw solid #F9F9F9;
        padding: 5.6vw 4vw;
        .related-title {
            font-size: 4.8vw;
            color: #0076FF;
            line-height: 4.8vw;
            padding-left: 2vw;
            border-left: 4px solid #0076FF;
        }
        .wap-newsList {
            padding-left: 0;
            padding-right: 0;
        }
    }
}
</style>